import { render, staticRenderFns } from "./ArtworkCreateModal.vue?vue&type=template&id=56146dbd&scoped=true"
import script from "./ArtworkCreateModal.vue?vue&type=script&lang=js"
export * from "./ArtworkCreateModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkCreateModal.vue?vue&type=style&index=0&id=56146dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56146dbd",
  null
  
)

export default component.exports